import DescriptionList from './DescriptionList'
import { Section } from './Section'

export default new Map([
    ['description-list', DescriptionList],
    [undefined, Section],
])
